export default __webpack_public_path__ + "static/media/people6.20d493c2.svg";